import Model from '../Model'
import moment from "moment";
import {uuid} from "../../utils";

export default class PurchaseOrder extends Model {
    getDownloadUrl() {
        return route('api.v2.procurement.purchase-order.pdf', [this.id])
    }

    getFormAttributes() {
        return this;
    }

    static parseAttributes(attributes = {}) {
        return attributes;
    }

    setAttributes(attributes) {
        super.setAttributes(attributes);
        if (attributes.date) {
            this.formatted_date = moment(attributes.date).format("DD/MM/YYYY");
        } else {
            this.formatted_date = "-- No Date Set --";
        }
        let tokens = [
            attributes.formatted_date,
            attributes.additionalInfo,
            attributes.reference,
            attributes.supplier,
            attributes.supplierReference,
            attributes.status,
            ...(attributes.descriptions ? attributes.descriptions : []),
            ...(attributes.packageNames ? attributes.packageNames : []),
        ];
        if (attributes.date) {
            tokens.push(moment(attributes.date).format("MMMM Do, YYYY"));
        }
        this.tokens = tokens.join("|").toLowerCase();
    }

    getNotesUrl() {
        return route("api.v2.procurement.purchase-order.notes.list", {
            id: this.id,
        });
    }

    postNotesUrl() {
        return route("api.v2.procurement.purchase-order.notes.store", {
            id: this.id,
        });
    }

    static async find(id) {
        const data = await Http.get(route("api.v2.procurement.purchase-order", [id]));
        return this.make(data);
    }

    static async search(packageReference = null, term) {
        const params = {search: term};
        let data;
        if (packageReference) {
            data = await Http.get(
                route("api.v2.procurement.purchase-order.package.list", [packageReference]),
                {params}
            );
        } else {
            data = await Http.get(route("api.v2.procurement.purchase-order.list"), {params});
        }
        return this.make(data);
    }

    static async suppliers(packageReference = null) {
        let data
        if (packageReference) {
            data = await Http.get(route("api.v2.procurement.purchase-order.package.suppliers", [packageReference]));
        } else {
            data = await Http.get(route("api.v2.procurement.purchase-order.suppliers"));
        }
        return data;
    }

    static async sentTos(supplier = null) {
        return await Http.get(route("api.v2.procurement.purchase-order.sentTos") + '?supplier=' + supplier);
    }

    static async create(packageReference, id, attributes = {}) {
        let success;
        if (packageReference) {
            success = await Http.post(
                route("api.v2.procurement.purchase-order.package.create", [packageReference, id]),
                attributes
            );
        } else {
            success = await Http.post(
                route("api.v2.procurement.purchase-order.create", [id]),
                attributes
            );
        }
        const data = await Http.get(route("api.v2.procurement.purchase-order", [id]));
        return this.make(data);
    }

    async update(attributes = {}) {
        eventBus.$emit("aggregate-saving", this);
        const url = route("api.v2.procurement.purchase-order.store", [this.id]);
        const payload = this.constructor.parseAttributes({
            ...this.getFormAttributes(),
            ...attributes,
        });
        const success = await Http.put(url, payload);
        eventBus.$emit("aggregate-saved", this);
    }

    async pushToClassic() {
        eventBus.$emit("aggregate-saving", this);
        const url = route("api.v2.procurement.purchase-order.push-to-classic", [this.id]);
        const payload = this.constructor.parseAttributes({
            ...this.getFormAttributes(),
        });
        const success = await Http.put(url, payload);
        eventBus.$emit("aggregate-saved", this);
    }

    async markAsSent() {
        const url = route("api.v2.procurement.purchase-order.mark-as-sent", [this.id]);
        let success
        try {
            success = await Http.put(url)
        } catch (error) {
            return error.response
        }
        Object.assign(this, await PurchaseOrder.find(this.id));
        return success;
    }

    async send(attributes = {}) {
        const url = route("api.v2.procurement.purchase-order.send", [this.id]);
        let success
        try {
            success = await Http.post(url, attributes)
        } catch (error) {
            return error.response
        }
        Object.assign(this, await PurchaseOrder.find(this.id));
        return success;
    }

    async revise(attributes = {}) {
        const url = route("api.v2.procurement.purchase-order.revise", [this.id]);
        let success
        try {
            success = await Http.post(url, attributes)
        } catch (error) {
            return error.response
        }
        Object.assign(this, await PurchaseOrder.find(this.id));
        return success;
    }

    async revoke(sendRequestId) {
        const url = route('api.v2.procurement.purchase-order.revoke', [this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        Object.assign(this, await PurchaseOrder.find(this.id));
        return success;
    }

    async resend(sendRequestId) {
        const url = route('api.v2.procurement.purchase-order.resend', [this.id, sendRequestId])
        let success
        try {
            success = await Http.post(url, {})
        } catch (error) {
            return error.response
        }
        Object.assign(this, await PurchaseOrder.find(this.id));
        return success;
    }

    async void(attributes = {}) {
        const url = route("api.v2.procurement.purchase-order.void", [this.id]);
        const payload = this.constructor.parseAttributes({
            ...this.getFormAttributes(),
            ...attributes,
        });
        const success = await Http.put(url, payload);
        Object.assign(this, await PurchaseOrder.find(this.id));
    }

    async duplicate() {
        let data = this.getFormAttributes()
        data.id = uuid();
        let n = await PurchaseOrder.create(this.packageReference, data.id, data)
        Object.assign(n, data);
        await n.update()
        Object.assign(this, n);
    }

    async delete() {
        await Http.delete(route("api.v2.procurement.purchase-order.delete", [this.id]));
    }
}
